/**
 * Behavior of edit field
 */
export var EditUpdateBehavior;
(function (EditUpdateBehavior) {
    /**
     * When the input is changed
     */
    EditUpdateBehavior["OnChange"] = "onChange";
    /**
     * When the input is blurred
     */
    EditUpdateBehavior["OnBlur"] = "onBlur";
    /**
     * When the input is blurred
     */
    EditUpdateBehavior["OnEnter"] = "onEnter";
})(EditUpdateBehavior || (EditUpdateBehavior = {}));
//# sourceMappingURL=EditUpdateBehavior.js.map